<template>
  <div class="dashboard">
    <transition
      name="fade"
      mode="out-in"
    >
      <div
        class="center-spinner"
        v-if="loading && !noAuth"
      >
        <spinner
          size="100"
          :line-size="15"
          line-fg-color="#78FAAE"
          message="Ładowanie..."
          text-fg-color="white"
        />
      </div>
    </transition>
    <router-view
      v-show="!loading || noAuth"
      :loading="loading"
    >
      <div
        class="mobile-overlay"
        @click="toggleProgressBar(false)"
        v-if="isMobile && shouldShowProgressBar && progressBarState"
      />
      <div
        v-if="isMobile && shouldShowProgressBar"
        class="open-progress-bar-container"
        :class="progressBarState ? 'hide' : 'show'"
      >
        <button
          class="open-progress-bar-button"
          @click="toggleProgressBar(true)"
        >
          <span>
            Szczegóły wizyty
          </span>
          <svg svg-inline="" class="icon-arrow-right" role="presentation" focusable="false" width="48" height="48" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"><path d="M33.5 22.5h-17V42M28 17l5.5 5.5L28 28" stroke="currentColor" fill="none"/></svg>
        </button>
      </div>
      <step-progress-bar
        v-if="shouldShowProgressBar"
        :mobile-state="progressBarState"
        :slide-progress-bar="slideProgressBar"
        @close_bar="progressBarState = false"
      />
    </router-view>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Spinner from 'vue-simple-spinner';
import StepProgressBar from '~/StepProgressBar';
import L from 'leaflet';

export default {
  props: {
    promises: {
      default: () => [],
      type: Array,
    },
    slideProgressBar: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Spinner,
    StepProgressBar,
  },
  data() {
    return {
      loading: true,
      progressBarState: false,
    };
  },
  computed: {
    ...mapGetters({
      footerColor: 'brand/getFooterColor',
      loginStatus: 'auth/getAuthStatus',
      primaryColor: 'brand/getPrimaryColor',
      thirdColor: 'brand/getThirdColor',
      serviceStations: 'serviceStations/getServiceStations',
    }),
    shouldShowProgressBar() {
      const { path } = this.$route;
      return !(path.includes('next') || path.includes('history'));
    },
    isMobile() {
      return this.$mq === 'mobile' || this.$mq === 'xs';
    },
    noAuth() {
      return this.$route.path.includes('no_auth');
    },
  },
  methods: {
    ...mapActions({
      setUserInfo: 'user/setUserInfo',
      getMyCars: 'myCars/fetchMyCars',
      setCurrentPosition: 'geolocation/setCurrentPosition',
      setClosestStation: 'serviceStations/setClosest',
    }),
    toggleProgressBar(value) {
      this.progressBarState = value;
    },
    geolocate() {
      const options = {
        enableHighAccuracy: true,
        timeout: 50000,
        maximumAge: 0,
      };

      return new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject, options);
      });
    },
  },
  watch: {
    '$route.name': function () {
      this.progressBarState = false;
    },
  },
  mounted() {
    if (this.loginStatus.loggedIn) {
      const requiredPromises = [this.setUserInfo(), this.getMyCars(), ...this.promises];

      Promise.all(requiredPromises)
        .then(() => {
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    }

    this.geolocate()
      .then((pos) => {
        const coords = {
          lat: pos.coords.latitude,
          lng: pos.coords.longitude,
        };

        Promise.all([
          this.setCurrentPosition(coords),
          this.promises[1], // service stations promise
        ])
          .then(() => {
            const filteredServiceStations = this.serviceStations.filter(station => station.isActive && station.location.lat && station.location.lng);
            const distances = filteredServiceStations.map((station) => {
              const servicePosition = L.latLng({ lat: parseFloat(station.location.lat), lng: parseFloat(station.location.lng) });
              const myPosition = L.latLng(coords);

              return {
                stationID: station.id,
                distance: myPosition.distanceTo(servicePosition),
              };
            });

            const closestStation = distances.reduce((res, obj) => ((obj.distance < res.distance) ? obj : res));

            this.setClosestStation({ id: closestStation.stationID });
          });
      })
      .catch((err) => {
        console.warn(`ERROR(${err.code}): ${err.message}`);
      });
  },
};
</script>
